export const publicPaths: Array<string> = [
  "/login",
  "/signup",
  "/logout",
  "/tariffs",
];

export * from "./components";
